/* ============================================================
   CAM - Sections de contenu (FAQ, avis, rappel final).

   Trois choses seulement, sans aucune dependance :
   1. accordeon FAQ (hauteur animee, un seul panneau ouvert) ;
   2. puces de la piste d'avis en mobile ;
   3. bouton du rappel final, qui DELEGUE au bouton de la zone
      d'achat : variante, pack, quantite et paiement direct sont
      donc hérités, et il n'existe qu'un seul moteur d'achat.
   ============================================================ */
(function () {
  'use strict';

  var MARQUE = 'camContenuPret';

  function chacun(l, f) { Array.prototype.forEach.call(l, f); }

  /* ---------------- FAQ ---------------- */

  function brancherFaq(bloc) {
    var items = bloc.querySelectorAll('[data-cam-faq-item]');
    var unSeul = bloc.getAttribute('data-cam-faq-single') === 'true';

    function fermer(it) {
      it.setAttribute('data-open', 'false');
      var q = it.querySelector('[data-cam-faq-q]');
      var a = it.querySelector('[data-cam-faq-a]');
      if (q) { q.setAttribute('aria-expanded', 'false'); }
      if (a) { a.style.maxHeight = '0px'; }
    }

    function ouvrir(it) {
      it.setAttribute('data-open', 'true');
      var q = it.querySelector('[data-cam-faq-q]');
      var a = it.querySelector('[data-cam-faq-a]');
      if (q) { q.setAttribute('aria-expanded', 'true'); }
      /* scrollHeight : la hauteur reelle du contenu, pas une valeur en dur. */
      if (a) { a.style.maxHeight = a.scrollHeight + 'px'; }
    }

    chacun(items, function (it) {
      var q = it.querySelector('[data-cam-faq-q]');
      if (!q) { return; }

      if (it.getAttribute('data-open') === 'true') { ouvrir(it); } else { fermer(it); }

      q.addEventListener('click', function () {
        var ouvert = it.getAttribute('data-open') === 'true';
        if (unSeul) {
          chacun(items, function (x) { if (x !== it) { fermer(x); } });
        }
        if (ouvert) { fermer(it); } else { ouvrir(it); }
      });
    });

    /* Un panneau ouvert doit se re-mesurer si la largeur change. */
    window.addEventListener('resize', function () {
      chacun(items, function (it) {
        if (it.getAttribute('data-open') !== 'true') { return; }
        var a = it.querySelector('[data-cam-faq-a]');
        if (a) { a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    }, { passive: true });
  }

  /* ---------------- Puces des avis ---------------- */

  function brancherAvis(bloc) {
    var piste = bloc.querySelector('[data-cam-revs]');
    var puces = bloc.querySelectorAll('[data-cam-rev-dot]');
    if (!piste || !puces.length) { return; }

    var cartes = piste.querySelectorAll('[data-cam-rev]');

    function marquer(i) {
      chacun(puces, function (p, k) {
        p.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
    }

    function index() {
      if (!cartes.length) { return 0; }
      var l = cartes[0].getBoundingClientRect().width || 1;
      return Math.max(0, Math.min(cartes.length - 1, Math.round(piste.scrollLeft / l)));
    }

    chacun(puces, function (p, i) {
      p.addEventListener('click', function () {
        if (!cartes[i]) { return; }
        var l = cartes[0].getBoundingClientRect().width || 0;
        try { piste.scrollTo({ left: Math.round(i * l), behavior: 'smooth' }); }
        catch (e) { piste.scrollLeft = Math.round(i * l); }
        marquer(i);
      });
    });

    var dernier = 0;
    piste.addEventListener('scroll', function () {
      var t = Date.now();
      if (t - dernier < 90) { return; }
      dernier = t;
      marquer(index());
    }, { passive: true });

    marquer(0);
  }

  /* ---------------- Rappel final ---------------- */

  function brancherFinal(bloc) {
    var bouton = bloc.querySelector('[data-cam-fcta]');
    if (!bouton) { return; }

    var hero = document.querySelector('.cam-s1');
    var ctaHero = hero ? hero.querySelector('[data-cam-cta]') : null;

    /* Sans zone d'achat sur la page, le bouton redevient un simple lien
       vers l'ancre : jamais de bouton mort. */
    if (!ctaHero) {
      bouton.addEventListener('click', function () {
        var cible = document.querySelector('#cam-buybox') || document.querySelector('#cam-hero');
        if (cible) { cible.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });
      return;
    }

    bouton.addEventListener('click', function (e) {
      e.preventDefault();
      ctaHero.click();
    });

    /* Le libelle et l'etat suivent ceux du bouton principal (rupture de
       stock comprise) : un seul endroit decide. */
    var txt = bouton.querySelector('[data-cam-fcta-text]');
    var txtHero = ctaHero.querySelector('[data-cam-cta-text]');

    function refleter() {
      if (txt && txtHero) { txt.textContent = txtHero.textContent; }
      bouton.disabled = ctaHero.disabled;
    }

    if (window.MutationObserver && txtHero) {
      new window.MutationObserver(refleter).observe(ctaHero, {
        childList: true, characterData: true, subtree: true,
        attributes: true, attributeFilter: ['disabled']
      });
    }
    window.setTimeout(refleter, 60);
  }

  /* ---------------- Initialisation ---------------- */

  function init(racine) {
    var portee = racine && racine.querySelectorAll ? racine : document;

    chacun(portee.querySelectorAll('[data-cam-faq]'), function (b) {
      if (b.dataset[MARQUE] === '1') { return; }
      b.dataset[MARQUE] = '1';
      brancherFaq(b);
    });

    chacun(portee.querySelectorAll('[data-cam-reviews]'), function (b) {
      if (b.dataset[MARQUE] === '1') { return; }
      b.dataset[MARQUE] = '1';
      brancherAvis(b);
    });

    chacun(portee.querySelectorAll('[data-cam-final]'), function (b) {
      if (b.dataset[MARQUE] === '1') { return; }
      b.dataset[MARQUE] = '1';
      brancherFinal(b);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();